import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AutomationDriftWarningComponent } from './shared/automation-drift-warning/automation-drift-warning.component';

@Component({
  imports: [AutomationDriftWarningComponent, RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
